import { render, staticRenderFns } from "./SerproStatus.vue?vue&type=template&id=9870d96c&"
import script from "./SerproStatus.vue?vue&type=script&lang=js&"
export * from "./SerproStatus.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports